import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import {
  SIDEBAR_VIEWS,
  usePublicLiveStore,
  usePublicLiveStoreActions,
} from "../store";
import { Chat } from "./Chat";
import { Header } from "./Header";
import { Participants } from "./Participants";

export const Sidebar = () => {
  const { hideSidebar } = usePublicLiveStoreActions();
  const { sidebarView } = usePublicLiveStore();
  const isSidebarOpen = !!sidebarView;
  const isChatActive = sidebarView === SIDEBAR_VIEWS.CHAT;

  return (
    <div
      className={classNames(
        "border-primary bg-primary my-4 mr-4 flex w-96 shrink-0 flex-col items-stretch rounded-lg border-l",
        {
          hidden: !isSidebarOpen,
        },
      )}
    >
      <Header
        title={t(
          isChatActive
            ? "live_streams.room.chat"
            : "live_streams.room.participants",
        )}
        onClick={hideSidebar}
      />
      {isChatActive ? <Chat /> : <Participants />}
    </div>
  );
};
